import { PRODUCT_CODE_KEY } from '@/shared/constants/storage.constants'
import { ProductCode, TravelDirection } from '@/shared/types/common.types'
import { useUserStore } from '@/shared/store'
import { InboundFlowRoutes } from '@/shared/types/router.types'
import { type RouteLocationNormalized, type NavigationGuardNext } from 'vue-router'
import { getHomeUrl } from '@/shared/utils/GetHomeUrl'

const setProductCode = (code: ProductCode) => {
  localStorage.setItem(PRODUCT_CODE_KEY, code)
}

export const setInboundProductCode = setProductCode.bind(null, ProductCode.INBOUND)
export const setOutboundProductCode = setProductCode.bind(null, ProductCode.OUTBOUND)

export const checkRequiredFields = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const userStore = useUserStore()
  const isOutbound = to.meta.name === TravelDirection.OUTBOUND
  const locale = typeof to.params.locale === 'string' ? to.params.locale : 'en'
  const hasAllData =
    userStore.departureDate &&
    userStore.returnDate &&
    userStore.tripType &&
    userStore.adultsCount &&
    userStore.childrenCount !== undefined &&
    userStore.childrenCount !== null &&
    (isOutbound
      ? userStore.destination.length > 0
      : Object.keys(userStore.residenceCountry || {}).length > 0)

  if (hasAllData) {
    next()
    return
  }

  if (isOutbound) {
    window.location.href = getHomeUrl(locale, userStore.redirectURL)
    return
  }

  next({ name: InboundFlowRoutes.RESIDENCE, params: { locale } })
}
